import React, { useState, useContext } from "react";

import PlusIcon from "../../icons/plus-icon";
import FeesIcon from "../../icons/fees-icon";
import BalanceIcon from "../../icons/balance-icon";

import { PopUpContext } from "../../contexts/popUpContext";
import useParityAccess, { useAccessReady } from "../common/useParityAccess";

import lbl from "../../data/Labels.json";

const FabButtons = ({ cache }) => {
  const [open, setOpen] = useState(false);
  const { togglePopUp } = useContext(PopUpContext);
  const can = useParityAccess();
  const ready = useAccessReady();
  const canPay = !ready || can("create-staff-salary-payment");

  return (
    <div className={`fab-container ${open ? "active" : ""}`} style={{paddingLeft: 0, width: open ? "150px" : "50px"}}>
      <button
        className="secondary"
        onClick={() => togglePopUp({ form: "staff-balance-form", cache })}
      >
        <BalanceIcon />
        <span>{lbl.OpeningBalance}</span>
      </button>
      {canPay ? (
      <button
        className="secondary"
        onClick={() => togglePopUp({ form: "staff-payment-form", cache })}
      >
        <FeesIcon />
        <span>{lbl.Payment}</span>
      </button>
      ) : null}
      <button className="primary" onClick={() => setOpen(!open)}>
        <PlusIcon />
        <span>{lbl.Cancel}</span>
      </button>
    </div>
  );
};

export default FabButtons;
